import { useEffect } from 'react';
import { getSettings } from '../api';

/**
 * Fetches the public site settings and injects a
 * <meta name="google-site-verification" ...> tag into <head> when the admin
 * has configured one. Runs once at app boot — same /api/settings call as Home,
 * so it usually rides the existing browser cache.
 */
export default function useGoogleSiteVerification() {
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const s = await getSettings();
        if (cancelled) return;
        const code = (s && s.google_site_verification || '').trim();
        if (!code) return;
        let el = document.head.querySelector('meta[name="google-site-verification"]');
        if (!el) {
          el = document.createElement('meta');
          el.setAttribute('name', 'google-site-verification');
          document.head.appendChild(el);
        }
        el.setAttribute('content', code);
      } catch (_) {
        // silent — verification is optional
      }
    })();
    return () => { cancelled = true; };
  }, []);
}
